import { render, staticRenderFns } from "./WidgetSettingsSolid.vue?vue&type=template&id=6dc12144&"
import script from "./WidgetSettingsSolid.vue?vue&type=script&lang=ts&"
export * from "./WidgetSettingsSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports